import { Modal } from "antd"
import { useDeactivateEventTicketTier } from "@mimber/client/mimber-organization"
import { message } from "@mimber/ui-web"
import type { EventTicketTierDto } from "@mimber/schema"

export const useDeactivateEventTicketTierModal = (
  eventUuid: string,
  onSuccess?: () => void
) => {
  const [modal, contextHolder] = Modal.useModal()
  const deactivateMutation = useDeactivateEventTicketTier(eventUuid)

  const showDeactivateEventTicketTierModal = (
    tier: EventTicketTierDto
  ): void => {
    modal.confirm({
      title: "Deactivate Ticket Tier",
      content: `Are you sure you want to deactivate "${tier.name}"? This will prevent new ticket purchases for this tier.`,
      okText: "Deactivate",
      okType: "danger",
      cancelText: "Cancel",
      onOk: () =>
        new Promise<void>((resolve, reject) => {
          deactivateMutation.mutate(tier.uuid, {
            onSuccess: () => {
              message.success("Ticket tier deactivated")
              onSuccess?.()
              resolve()
            },
            onError: (error) => {
              message.error(`Failed to deactivate: ${error.message}`)
              reject()
            },
          })
        }),
    })
  }

  return {
    contextHolder,
    showDeactivateEventTicketTierModal,
  }
}
